import React, { useContext, VFC } from 'react';

import { sortBy } from 'lodash';

import ArticleBlock from '/components/ArticleBlock';
import {
  ContentColumn,
  MediaColumn,
  IMAGE_SIZE,
} from '/components/BlockColumns';
import { LAYOUT, useColsCollapsed } from '/components/common';
import Title from '/components/Title';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';

const BlockContentMedia: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  presentOption,
  blockContent,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const colsCollapsed = useColsCollapsed();
  const columnData = blockContent?.columns?.list || [];
  const layout = blockContent?.columns?.layout;

  // Media first when collapsed or if wider column is to the right
  const orderedColumns =
    colsCollapsed || layout == LAYOUT.RIGHT
      ? sortBy(columnData, (column) => (column.name === 'media' ? 0 : 1))
      : columnData;
  setAnimationComplete(animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      hideFooter={animationEnabled && !animationStep}
      offset={!!presentMode ? 1 : 2}
      titleWithinColumn
      columns={orderedColumns.map((column: ColumnContainerJson) => (
        <>
          {column.name === 'media' && (
            <MediaColumn
              elements={column.elements}
              imageSize={IMAGE_SIZE.SMALL}
              presentOption={presentOption}
              hide={animationEnabled && !animationStep}
            />
          )}
          {column.name === 'content' && (
            <>
              <Title
                content={blockContent?.title?.content}
                hidden={colsCollapsed || blockContent?.title?.hidden}
              />
              <ContentColumn
                elements={column.elements}
                presentOption={presentOption}
                hide={animationEnabled && !animationStep}
              />
            </>
          )}
        </>
      ))}
    />
  );
};

BlockContentMedia.displayName = 'BlockContentMedia';
export default BlockContentMedia;
